<template>
	<footer class="mt-2 mb-3 pt-3 border-top">
		<div class="row">

			<!-- Organisation Logo -->
			<div class="col-12 mb-2 mobile-mb-0" v-if="tenant.logo">
				<img style="width:120px;" :src="tenant.logo" :alt="tenant.name" v-if="tenant.logo"/>
			</div>

			<!-- Organisation Details -->
			<div class="col-6 pt-2 text-grey text-13">

				<!-- Organisation Name -->
				<div class="mb-1" v-if="tenant.name">
					<i class="fad fa-user fa-fw mr-2"></i>
					{{ tenant.name }}
				</div>

				<!-- Registration Number -->
				<div class="mb-1 footer-registration-number" v-if="tenant.registration_number">
					({{ tenant.registration_number }})
				</div>

				<!-- Office Number -->
				<div class="mb-1" v-if="tenant.office_no">
					<i class="fad fa-phone-office fa-fw mr-2"></i>
					{{ tenant.office_no }}
				</div>

				<!-- Email -->
				<div class="mb-1" v-if="tenant.email">
					<i class="fad fa-envelope-open fa-fw mr-2"></i>
					{{ tenant.email }}
				</div>

				<!-- Address -->
				<div class="row ml-0" v-if="tenant.addressLine1">
					<div class="d-inline">
						<i class="fad fa-map-marker-alt fa-fw mr-2"></i>
					</div>
					<div class="d-inline address">
						<span v-html="tenant.addressLine1"></span>
						<span v-html="tenant.addressLine2"></span>
					</div>
				</div>
			</div>

			<!-- Social Media -->
			<div class="col-3 pt-2 text-left">
				<div class="social-media">
					<h6 class="mb-3">
						Media Sosial
					</h6>
					<ul class="list-inline text-13">

						<!-- Facebook -->
						<li class="mb-2">
							<a target="_facebook" :href="'//' + tenant.facebook_url" class="mr-3" v-if="tenant.facebook_url">
								<i class="fab fa-facebook-square fa-fw mr-1"></i>
								Facebook
							</a>
						</li>

						<!-- Telegram -->
						<li class="mb-2">
							<a target="_telegram" :href="'//' + tenant.telegram_url" class="mr-3" v-if="tenant.telegram_url">
								<i class="fab fa-telegram-plane fa-fw mr-1"></i>
								Telegram
							</a>
						</li>

						<!-- Youtube -->
						<li class="mb-2">
							<a target="_youtube" :href="'//' + tenant.youtube_url" class="mr-3" v-if="tenant.youtube_url">
								<i class="fab fa-youtube fa-fw mr-1"></i>
								Youtube
							</a>
						</li>

						<!-- WhatsApp -->
						<li class="mb-2">
							<a target="_whatsapp" :href="'//' + tenant.whatsapp_url" class="mr-3" v-if="tenant.whatsapp_url">
								<i class="fab fa-whatsapp fa-fw mr-1"></i>
								WhatsApp
							</a>
						</li>

						<!-- TikTok -->
						<li>
							<a target="_tiktok" :href="'//' + tenant.tiktok_url" class="mr-3" v-if="tenant.tiktok_url">
								<i class="fab fa-tiktok fa-fw mr-1"></i>
								TikTok
							</a>
						</li>
					</ul>
				</div>
			</div>

			<!-- Akaun -->
			<div class="col-3 pt-2 text-left">
				<div class="social-media">
					<h6 class="mb-3">
						Akaun
					</h6>
					<ul class="list-inline text-13">
						<li class="mb-2">
							<a href="/participant/login">
								Akaun Saya
							</a>
						</li>
						<li class="mb-2">
							<a href="/participant/login">
								Jejak Transaksi
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</footer>
</template>

<!-- Scripts -->
<script>
export default {
	name: "FooterSection",
	props: {
		tenant: Object
	}
}
</script>